// extracted by mini-css-extract-plugin
export default {"JobworkList":"JobworkList_JobworkList__YfkXw"};